export default {
  applied: "Setelah Pendaftaran",
  accept: "Diterima",
  reject: "Ditolak"
};
